module.exports = __webpack_public_path__ + "static/media/charlotte-moroz-songs-reduced.d6ed0f85.jpg";